import { render } from "./updateRole.vue?vue&type=template&id=3736fc64&scoped=true"
import script from "./updateRole.vue?vue&type=script&lang=js"
export * from "./updateRole.vue?vue&type=script&lang=js"

import "./updateRole.vue?vue&type=style&index=0&id=3736fc64&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3736fc64"]])

export default __exports__